<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader :page-name="pageName" parent-page-name="Branding And Logo" parent-page-url="/branding-and-logo" />
      <add-edit-form
        v-if="model"
        returnUrl="/branding-and-logo"
        :apiBaseUrl="API_BASE_URL"
        :model="model"
        :fields="fields"
        :toEdit="toEdit"
      />
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
import Pageheader from '@/components/Pageheader.vue'
import AddEditForm from '@/components/AddEditForm.vue'
import Branding from '@/models/Branding'
/* eslint-disable no-undef */
export default {
  name: 'AddBranding',
  components: {
    Pageheader,
    AddEditForm
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    },
    pageName () {
      return this.toEdit ? 'Edit Branding' : 'Add Branding'
    }
  },
  data () {
    return {
      API_BASE_URL: 'branding',
      model: null,
      fields: [
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Sort number', key: 'sort_no', type: 'number' },
        { label: 'PSD Format', key: 'PSD', type: 'format' },
        { label: 'EPS Format', key: 'EPS', type: 'format' },
        { label: 'PNG Format', key: 'PNG', type: 'format' },
        { label: 'PDF Format', key: 'PDF', type: 'format' },
        { label: 'JPG Format', key: 'JPG', type: 'format' },
        { label: 'Word Format', key: 'WORD_DOC', type: 'format' },
        { label: 'AI Format', key: 'AI', type: 'format' },
        { label: 'All Formats', key: 'ALL', type: 'format' }
      ]
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetch()
    } else {
      this.model = new Branding()
    }
  },
  methods: {
    fetch () {
      this.$store.dispatch(this.API_BASE_URL + '/get', this.$route.params.id)
        .then((result) => {
          this.model = new Branding(result.branding)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Brandings/AddEdit.vue